<template>

  <div class="faq faq_how_to_new">

    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-9 col-xl-7 col-xxl-8" v-if="widgetData.description && widgetData.description.length > 0">
        <div class="mt-3 mb-4">
          <div v-html="widgetData.description"></div>
        </div>
      </div>
    </div>

    <div class="row d-flex justify-content-center">
      <div class="col-12 card-group" v-for="(menuItem, step) in content" :key="`c_${menuItem.id}`">
        <div class="card border-0 mb-3" :data-info="step + 1">
          <div v-if="menuItem.text && menuItem.text.length > 5" v-html="menuItem.text" class="pb-0"></div>
          <figure class="shadow_3 pointer" @click="openGallery(menuItem.image.id)" v-if="menuItem.hasImage()">
            <picture>
              <PartsSrcSetImage :image="menuItem.image" :t_type="'cache'" :type="'webp'"/>
              <PartsSrcSetImage :image="menuItem.image" :t_type="'cache'" :type="'jpeg'"/>
              <img :src="menuItem.image.getTyrionSrc('cache')" :alt="menuItem.name" class="img-cover" loading="lazy"
                   :width="menuItem.image.seoWidth('cache')" :height="menuItem.image.seoHeight('cache')"/>
            </picture>
          </figure>
        </div>
      </div>
    </div>

    <ClientOnly>
      <ImgViewr ref="imgViewerFaqNew" :initial-index="galleryImageIndex" :onClose="closeGallery" :urls="imgViewerImages" :visible="galleryImageVisible"/>
    </ClientOnly>
  </div>

</template>

<script setup lang="ts">

import "~/assets/less/_faq.min.css";
import {PropType, ref} from "vue";
import {PageDataHolderFetchedWidget} from "../../../../lib/interfaces/model/PageDataHolderFetchedWidget";
import Image from "../../../../lib/models/Image";
import {TyrionResourceImageType} from "../../../../lib/enums/TyrionResourceImageType";
import {useNuxtApp} from "#app";
import ImgViewr from 'vue-img-viewr';
import 'vue-img-viewr/styles/index.css';
import {useWidget} from "../../../../composables/widget/menu";

const {$showWebp} = useNuxtApp();

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const {widgetData, content} = useWidget(props.widget);
const imgViewerImages = ref([]);
const galleryImageIndex = ref(1);
const galleryImageVisible = ref(false);
const imgViewerFaqNew = ref(null);

const images = [];
content.forEach((menuItem) => {
  if (menuItem.hasImage()) {
    images.push(menuItem.image);
  }
})

imgViewerImages.value = images.map((image: Image) => {
  return image.getTyrionSrc(TyrionResourceImageType.CacheSrc, $showWebp ? 'webp' : null);
});

const openGallery = (imageId: number) => {
  const index = content.map(mItem => mItem.hasImage() ? mItem.image : null).filter(mItem => mItem !== null).findIndex(mItem => mItem.id == imageId);

  setTimeout(() => {
    galleryImageIndex.value = index;
    galleryImageVisible.value = true;
    imgViewerFaqNew.value.index = index;
  }, 100)

}

const closeGallery = () => {
  galleryImageVisible.value = false;
  setTimeout(() => {
    galleryImageIndex.value = 0;
    imgViewerFaqNew.value.index = 0;
  }, 300);

}

</script>



